import { Instance, types } from 'mobx-state-tree';

export const NavState = types
  .model('NavState', {
    current: types.string,
    isFinal: types.maybe(types.boolean),
    isStart: types.maybe(types.boolean),
    path: types.array(types.string),
  });
export type INavState = Instance<typeof NavState>;
